"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkList = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _NavLink = require("../nav-link/NavLink");
var _bell = require("../../../assets/icons/bell.svg");
var _cog = require("../../../assets/icons/cog.svg");
var _userDefault = require("../../../assets/icons/user-default.svg");
var _help = require("../../../assets/icons/help.svg");
var _externalLink = require("../../../assets/icons/external-link.svg");
var _NavDropdown = require("../nav-dropdown/NavDropdown");
var _NavButton = require("../nav-button/NavButton");
var _linkListModule = _interopRequireDefault(require("./link-list.module.scss"));
var IconComponents = {
  bell: _bell.ReactComponent,
  cog: _cog.ReactComponent,
  user: _userDefault.ReactComponent,
  help: _help.ReactComponent,
  externalLink: _externalLink.ReactComponent
};
var LinkList = function LinkList(props) {
  var categories = props.categories,
    className = props.className,
    _props$onCategoryClic = props.onCategoryClick,
    onCategoryClick = _props$onCategoryClic === void 0 ? function () {} : _props$onCategoryClic;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames4.default)(_linkListModule.default.list, className)
  }, categories.map(function (_ref) {
    var _classnames;
    var id = _ref.id,
      title = _ref.title,
      href = _ref.href,
      external = _ref.external,
      target = _ref.target,
      CustomComponent = _ref.CustomComponent,
      type = _ref.type,
      icon = _ref.icon,
      hideForMobileScreens = _ref.hideForMobileScreens,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      active = _ref.active,
      visible = _ref.visible,
      notificationCount = _ref.notificationCount;
    var Icon = icon && IconComponents[icon];
    return /*#__PURE__*/_react.default.createElement("li", {
      key: id,
      onClick: function onClick(e) {
        return onCategoryClick(e, id);
      },
      className: (0, _classnames4.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, _linkListModule.default.item, true), (0, _defineProperty2.default)(_classnames, _linkListModule.default['with-small-icon'], icon && title), (0, _defineProperty2.default)(_classnames, _linkListModule.default['hide-mobile-screen'], hideForMobileScreens), _classnames))
    }, type !== 'button' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, items.length ? /*#__PURE__*/_react.default.createElement(_NavDropdown.NavDropdown, {
      items: items,
      visible: visible,
      active: active
    }, Icon && /*#__PURE__*/_react.default.createElement(Icon, {
      className: (0, _classnames4.default)((0, _defineProperty2.default)({}, _linkListModule.default['small-icon'], !!title))
    }), title) : /*#__PURE__*/_react.default.createElement(_NavLink.NavLink, {
      href: href,
      active: active,
      notificationCount: notificationCount,
      external: external,
      target: target
    }, Icon && /*#__PURE__*/_react.default.createElement(Icon, {
      className: (0, _classnames4.default)((0, _defineProperty2.default)({}, _linkListModule.default['small-icon'], !!title))
    }), title)) : /*#__PURE__*/_react.default.createElement(_NavButton.NavButton, {
      items: items,
      title: title,
      visible: visible
    }), CustomComponent && visible && /*#__PURE__*/_react.default.createElement("div", {
      className: _linkListModule.default['custom-component']
    }, /*#__PURE__*/_react.default.createElement(CustomComponent, null)));
  }));
};
exports.LinkList = LinkList;